"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "porto-azzurro": {
    "d08ac8b5": [{
      "hkey": "2bb7bb07",
      "slug": "porto-azzurro",
      "name": "Porto Azzurro",
      "primary": true,
      "skipSearch": false
    }],
    "barbarossa": [{
      "hkey": "2bb7bb07",
      "slug": "porto-azzurro",
      "name": "Porto Azzurro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "7d413fca": [{
      "hkey": "2bb7bb07",
      "slug": "porto-azzurro",
      "name": "Porto Azzurro",
      "primary": true,
      "skipSearch": false
    }],
    "mola": [{
      "hkey": "2bb7bb07",
      "slug": "porto-azzurro",
      "name": "Porto Azzurro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;